<div class="bg-danger" style="margin-top: 15px;">

    @if (isMapConsentGiven) {

        <mat-form-field>
            <mat-label>Filter</mat-label>
            <mat-select [formControl]="selectedFilter" multiple (selectionChange)="changeFilter($event)">
                @for (filter of filters; track filter.value) {
                    <mat-option [value]="filter.value">{{filter.viewValue}}</mat-option>
                }
            </mat-select>
        </mat-form-field>

        <div class = "d-flex justify-content-end">
            <button class="btn text-decoration-none" (click)="onRevokeMapConsentClicked()">
                "Google-Maps-Zustimmung widerrufen"
            </button>

        </div>

        <div id="map"></div>
    }
   @else {
       <avs-map-consent></avs-map-consent>
     }

</div>